export const DATE_OF_USER_CREATION_TO_HIDE_MENU = new Date(2023, 4, 1); // 2023-may-01

export const DEFAULT_EXPORT_PAGE_SIZE = 25;

export const DEFAULT_ENTITY_LIST_PAGE_SIZE = 6;
